import promise from 'promise';
import api from 'app/shared/utils/api';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import NotificationSettings from 'app/shared/model/NotificationSettings';

const NotificationActions = {
    register(subscription) {
        const params = {
            deviceId: JSON.stringify(subscription),
        };

        return dispatch => dispatch(api.notifications.register(params))
            .then((response = {}) => {
                const { error: errorRMWModel, success } = response;

                if (success === false) {
                    return promise.reject(errorRMWModel);
                }

                return response;
            })
            .catch((errorRMWModel) => {
                console.error('ERROR @NotificationActions.register: ', errorRMWModel.message);
            });
    },
    unregister(subscription) {
        const params = {
            deviceId: JSON.stringify(subscription),
        };

        return dispatch => dispatch(api.notifications.unregister(params))
            .then((response = {}) => {
                const { error: errorRMWModel, success } = response;

                if (success === false) {
                    return promise.reject(errorRMWModel);
                }

                return response;
            })
            .catch((errorRMWModel) => {
                console.error('ERROR @NotificationActions.unregister: ', errorRMWModel.message);
            });
    },
    getSettings() {
        return dispatch => dispatch(api.notifications.getSettings())
            .then((result) => {
                if (result.success) {
                    const settings = NotificationSettings(result.response);

                    return dispatch({
                        type: DispatchConstants.NOTIFICATION_SETTINGS_GET_SUCCESS,
                        payload: settings,
                    });
                }
                return promise.reject(result.error);
            })
            .catch((errorRMWModel) => {
                console.error('ERROR @NotificationActions.getSettings: ', errorRMWModel.message);
            });
    },
    updateSettings(params) {
        return dispatch => dispatch(api.notifications.updateSettings(params))
            .then((result) => {
                if (result.success) {
                    return dispatch({
                        type: DispatchConstants.NOTIFICATION_SETTINGS_UPDATE_SUCCESS,
                        payload: {},
                    });
                }
                return promise.reject(result.error);
            })
            .catch((errorRMWModel) => {
                console.error('ERROR @NotificationActions.updateSettings: ', errorRMWModel.message);
            });
    },
};

export default NotificationActions;
